import React from 'react';

class WindowLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { browsingHistory: false };
    this.handlePopState = this.handlePopState.bind(this);
  }

  static omitParam(url, paramName) {
    const re = new RegExp(paramName + /(=(\w|\.|-)+)(&?)/.source);
    return url
      .replace(re, '') // remove param and its parts
      .replace(/(\?|&)?$/gi, ''); // Clean up last char if no params are left
  }

  get hasCustomState() {
    return this.props.state && this.props.stateKey;
  }

  get hasCallback() {
    return typeof this.props.onPopState === 'function';
  }

  componentDidMount() {
    if (this.hasCallback) {
      window.addEventListener('popstate', this.handlePopState);
      // componentWillUnmount will not be called on page unload
      window.onbeforeunload = () => {
        window.removeEventListener('popstate', this.handlePopState);
        window.onbeforeunload = null;
      };
    }
    this.updateHistoryState(this.props.state, this.props.url, true);
  }

  UNSAFE_componentWillReceiveProps({ state, url }) {
    if (!this.state.browsingHistory && url !== this.props.url) {
      this.updateHistoryState(state, url);
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.url !== this.props.url;
  }

  updateHistoryState(state, url, replace) {
    const nextState = { ...window.history.state };

    if (url) {
      // history.state.url is used by turbolinks, so i'm keeping it
      nextState.url = this.props.omitParam
        ? WindowLocation.omitParam(url, this.props.omitParam)
        : url;
    }

    if (this.hasCustomState) {
      nextState[this.props.stateKey] = state;
    }

    if (replace) {
      window.history.replaceState(nextState, null, nextState.url);
    } else {
      window.history.pushState(nextState, null, nextState.url);
    }
  }

  handlePopState({ state }) {
    this.setState({ browsingHistory: true }, () => {
      this.props.onPopState(state);
      this.setState({ browsingHistory: false });
    });
  }

  render() {
    return false;
  }
}

export default WindowLocation;
